"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDatasetItemInput = exports.validateDatasetItem = exports.datasetItemMatchesVariable = void 0;
const datasetItemMatchesVariable = (input, variable) => {
    if (input === null ||
        input === undefined ||
        typeof input !== "object" ||
        Array.isArray(input))
        return false;
    return Object.keys(input).includes(variable);
};
exports.datasetItemMatchesVariable = datasetItemMatchesVariable;
const isValidPrismaJsonObject = (input) => typeof input === "object" &&
    input !== null &&
    input !== undefined &&
    !Array.isArray(input);
/**
 * Validate dataset item input against prompt variables.
 * Allows plain strings if exactly one variable exists.
 */
const validateDatasetItem = (itemInput, variables) => {
    // String allowed if exactly 1 variable
    if (typeof itemInput === "string" &&
        itemInput !== "" &&
        variables.length === 1) {
        return true;
    }
    // Object validation: must have at least one matching variable
    if (!isValidPrismaJsonObject(itemInput)) {
        return false;
    }
    return variables.some((variable) => (0, exports.datasetItemMatchesVariable)(itemInput, variable));
};
exports.validateDatasetItem = validateDatasetItem;
/**
 * Normalize dataset item input to object format.
 * Auto-wraps strings into {variableName: string} for single-variable prompts.
 */
const normalizeDatasetItemInput = (itemInput, variables) => {
    // Auto-wrap string for single variable
    if (typeof itemInput === "string" && variables.length === 1) {
        return { [variables[0]]: itemInput };
    }
    // Pass through objects
    if (isValidPrismaJsonObject(itemInput)) {
        return itemInput;
    }
    throw new Error("Invalid dataset item input");
};
exports.normalizeDatasetItemInput = normalizeDatasetItemInput;
